import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Attribute } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Attribute>>>;

const getAllAttributesForCurrentUser = (): ReturnType => {
    return Request.get(`/attributes`);
};

export default getAllAttributesForCurrentUser;
